<template>
  <div>
    <div class="page-header">
      <div class="container-fluid d-flex align-items-center justify-content-between">
       <h2 class="h4 no-margin-bottom">Servis</h2>
       <div class="right-menu list-inline no-margin-bottom" v-if="$helper.sayfayetki(610696)">
          <router-link to="/liste/cihaz"><button type="submit" class="btn submit bg-dark text-light">Yeni Servis</button>
          </router-link>
          <router-link to="/malzemerapor"><button type="submit" class="btn submit bg-dark text-light">Malzeme Raporu</button>
          </router-link>
       </div>
      </div>
    </div>
    <section class="no-padding-top no-padding-bottom">
      <div class="container-fluid">
        <div class="row">
              <div v-for="(bir,iki) in this.$helper.groupByAdet(posts,'sd')" :key="bir"  class="col-md-3 col-sm-6">
                <div class="statistic-block block">
                  <div class="progress-details d-flex align-items-end justify-content-between">
                    <div class="title">
                      <div class="icon"><i class="icon-contract"></i></div><strong>{{iki}}</strong>
                    </div> 
                    <div class="number dashtext-2">{{bir}}</div>
                  </div>
                  <div class="progress progress-template">
                    <div role="progressbar" v-bind:style="{width :  (bir / posts.length)*100 + '%' }" class="progress-bar progress-bar-template dashbg-2"></div>
                  </div>
                </div>
              </div>
        </div>
      
        <div v-if="progres" class="row">
          <div class="col-lg-6 col-12">
                <div class="pie-chart chart block">
                  <div class="title"><strong>Aylara Göre({{donem}})</strong></div>
                  <div class="pie-chart chart margin-bottom-sm">
                      <apexchart type="pie" width="100%" :options="ay.chartOptions" :series="ay.series"></apexchart>
                  </div>
                </div>
          </div>
          <div class="col-lg-6 col-12">
                <div class="pie-chart chart block">
                  <div class="title"><strong>Bölgelere Tipine  ({{donem}})</strong></div>
                  <div class="pie-chart chart margin-bottom-sm">
                      <apexchart type="pie" width="100%" :options="bolge.chartOptions" :series="bolge.series"></apexchart>
                  </div>
                </div>
          </div>          
        </div>
        <div v-if="progres" class="row">
          <div class="col-lg-6 col-12">
                <div class="pie-chart chart block">
                  <div class="title"><strong>Sağlayıcıya Göre({{donem}})</strong></div>
                  <div class="pie-chart chart margin-bottom-sm">
                      <apexchart type="pie" width="100%" :options="sa.chartOptions" :series="sa.series"></apexchart>
                  </div>
                </div>
          </div>
          <div class="col-lg-6 col-12">
                <div class="pie-chart chart block">
                  <div class="title"><strong>Servis tipine göre  ({{donem}})</strong></div>
                  <div class="pie-chart chart margin-bottom-sm">
                      <apexchart type="pie" width="100%" :options="st.chartOptions" :series="st.series"></apexchart>
                  </div>
                </div>
          </div>          
        </div>          
        <div v-if="progres" class="row">
          <div class="col-lg-6 col-12">
                <div class="pie-chart chart block">
                  <div class="title"><strong>Teknik Kod ({{donem}})</strong></div>
                  <div class="pie-chart chart margin-bottom-sm">
                      <apexchart type="pie" width="100%" :options="ariza.chartOptions" :series="ariza.series"></apexchart>
                  </div>
                </div>
          </div>
          <div class="col-lg-6 col-12">
                <div class="pie-chart chart block">
                  <div class="title"><strong>Servis Nedeni ({{donem}})</strong></div>
                  <div class="pie-chart chart margin-bottom-sm">
                      <apexchart type="pie" width="100%" :options="sn.chartOptions" :series="sn.series"></apexchart>
                  </div>
                </div>
          </div>          
        </div>
      </div>
    </section>
    <div v-if="progres.inprogres">
      <div id="spinner-front" class="show"> <img src="/set/ajax-loader.gif"/><br>{{progres.mesaj}} ...</div>
      <div id="spinner-back" class="show"></div>
    </div>              
  </div>
</template>

<script>
export default {
   created() {
    this.progres.inprogres = true
    this.yetki();
  },
  data () {
    return {

      posts : [],
      error :[],
      donem : this.$request.donem(),
      st:{},
      sn:{},
      ariza:{},
      ay:{},
      sa:{},
      bolge:{},
      ayar:this.$request.ayar(),
      progres : {
        mesaj:'Bekleyiniz',
        inprogres:false
      }
    }
  },
    methods : {
yetki: function(){ // sayfa yetki
          if (this.$helper.sayfayetki(691274)){
            let islem =false;
            switch(this.ya) {
              case 'said':
                this.ya = 'said';
                islem = true
                break;
              case 'carid':
                this.ya='carid';
                islem = true;
                break;
              default:
                islem = true;
                this.ya = 'fid';
            }
                if(islem){this.getPostsAsync()}
          }
          else{
                alert('Bu alanı kullanım yetkiniz yok')
                this.$router.go(-1)
          }
        },

        getPostsAsync (){
          this.$request.get("servis/servis/"+this.ayar.ya+"/"+this.ayar.kid+"/"+this.donem+'/mikro')
          .then(res => {
            console.log(res)
            this.posts = res.results.sort((t1,t2) => t1.id < t2.id ? -1 : 1)
            this.st = this.piechart(this.$helper.groupByAdet(res.results,'ariza_kodu')),
            this.sn = this.piechart(this.$helper.groupByAdet(res.results,'sn')),
            this.st = this.piechart(this.$helper.groupByAdet(res.results,'st')),
            this.ariza = this.piechart(this.$helper.groupByAdet(res.results,'ariza_kodu')),
            this.ay = this.piechart(this.$helper.groupByAdet(res.results,'ay')),
            this.sa = this.piechart(this.$helper.groupByAdet(res.results,'sa')),
            this.bolge = this.piechart(this.$helper.groupByAdet(res.results,'bolge')),
            this.progres.inprogres = false
            })
          .catch(err => {this.error.push(err)})
        },
    piechart (array,keys){
      let serie = new Array;
           let label = new Array;
            Object.keys(array).forEach(function(key) {
              serie.push(array[key])
              label.push(key)
          })
          return {
            series:serie,
            chartOptions: {
            chart: {
                type: 'pie',
                foreColor: '#a5a7ab',
              },
              labels: label,
              colors: ['#ff009e',"#de65e6","#a696fe","#5dbcfe","#27b2dc","#53edff","#141518"],
            }
          }
    },        
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/servis/rapor.vue